(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6496],{

/***/ 20145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ _; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10518);
/* harmony import */ var _index_bd43cdd3_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11424);
/* harmony import */ var _Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42990);
(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.s)(".Pagination_pagination__3{display:flex;align-items:center;justify-content:center;height:80px;background-color:#fff}.Pagination_pagination__3 button{margin:0;padding:0;border-width:0;background-color:transparent;color:inherit;font:inherit;line-height:normal;text-align:inherit;text-decoration:none;cursor:pointer;overflow:visible;-webkit-appearance:none;-moz-appearance:none;appearance:none}.Pagination_pagination__3 button::-moz-focus-inner{padding:0;border:0}.Pagination_pagination--compact-mode__25{height:auto}.Pagination_pagination--compact-mode__25 .Pagination_pagination__compact-mode-spacer__27{width:16px;pointer-events:none}.Pagination_pagination__3 ul{display:flex;align-items:center;margin:0;padding:0;list-style:none}.Pagination_pagination__3 ul li{display:flex;align-items:center;justify-content:center;width:32px;height:32px;margin:0;padding:0;text-align:center}.Pagination_pagination__3 ul li a,.Pagination_pagination__3 ul li button{display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#000;font-size:.875rem;font-weight:600;line-height:1rem;text-decoration:none;cursor:pointer}.Pagination_pagination__3 ul li a .Pagination_toga-icon__58,.Pagination_pagination__3 ul li button .Pagination_toga-icon__58{font-size:1.25rem}.Pagination_pagination__3 ul li.Pagination_active__61{box-shadow:inset 0 -2px 0 #5668c7}.Pagination_pagination__3 ul li.Pagination_active__61 button{color:#5668c7}.Pagination_pagination__3 ul li.Pagination_inactive__65 button{cursor:default;opacity:.3}.Pagination_pagination__3 ul li.Pagination_inactive__65:focus,.Pagination_pagination__3 ul li.Pagination_inactive__65:hover{box-shadow:none}.Pagination_pagination__3 ul li.Pagination_pagination__index__70{display:none}@media screen and (min-width:664px){.Pagination_pagination__3 ul li.Pagination_pagination__index__70{display:flex}}.Pagination_pagination__3 ul li:focus,.Pagination_pagination__3 ul li:hover{box-shadow:inset 0 -2px 0 #000}.Pagination_pagination__3 ul li:focus button,.Pagination_pagination__3 ul li:hover button{color:#000}",{insertAt:"top"});var r=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.b.bind({pagination:"Pagination_pagination__3","pagination--compact-mode":"Pagination_pagination--compact-mode__25","pagination__compact-mode-spacer":"Pagination_pagination__compact-mode-spacer__27","toga-icon":"Pagination_toga-icon__58",active:"Pagination_active__61",inactive:"Pagination_inactive__65",pagination__index:"Pagination_pagination__index__70"}),c=function(n){var i=n.accessibilityLabel,t=n.className,e=n.currentPage,c=n.goTofirstHandler,_=n.goTolastHandler,g=n.previousHandler,s=n.nextHandler,p=n.goToPageHandler,d=n.desiredNumberOfPages,m=n.isCompactMode,u=n.totalPages,b=d>u?u:d,P=[],f=Math.floor(b/2),h=Math.max(e-f,1),v=i?(0,_index_bd43cdd3_js__WEBPACK_IMPORTED_MODULE_3__.n)():null;e>=u&&(h=u-b+1),e+f>u&&(h=u-b+1);for(var x=function(n){var i=n;P.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement("li",{className:r("pagination__index","pagination__item--".concat(i),{active:e===i}),key:i},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{type:"button",onClick:function(){return p(i)}},i)))},y=h;y<h+b;y+=1)x(y);var E=1===e,N=e===u;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("nav",{"aria-labelledby":v,className:r("pagination",t,{"pagination--compact-mode":m})},i&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("p",{className:"sr-only",id:v},i),react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul",null,!m&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("li",{className:r("toFirstBtn",{inactive:E})},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{"aria-disabled":E,"aria-label":"Go to the first page",type:"button",onClick:E?void 0:c},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_4__.I,{name:"bullet","aria-hidden":!0}))),react__WEBPACK_IMPORTED_MODULE_0__.createElement("li",{className:r("toPreviousBtn",{inactive:E})},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{"aria-disabled":E,"aria-label":"Go to the previous page",type:"button",onClick:E?void 0:g},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_4__.I,{name:"arrow-left","aria-hidden":!0}))),!m&&P,m&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("li",{"aria-hidden":"true",className:r("pagination__compact-mode-spacer")}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("li",{className:r("toNextBtn",{inactive:N})},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{"aria-disabled":N,"aria-label":"Go to the next page",type:"button",onClick:N?void 0:s},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_4__.I,{name:"arrow-right","aria-hidden":!0}))),!m&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("li",{className:r("toLastBtn",{inactive:N})},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{"aria-disabled":N,"aria-label":"Go to the last page",type:"button",onClick:N?void 0:_},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_4__.I,{name:"bullet","aria-hidden":!0})))))};c.propTypes={accessibilityLabel:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,currentPage:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number.isRequired),desiredNumberOfPages:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),goTofirstHandler:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),goTolastHandler:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),goToPageHandler:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),isCompactMode:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),nextHandler:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),previousHandler:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),totalPages:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number.isRequired)},c.defaultProps={goTofirstHandler:function(){},goTolastHandler:function(){},previousHandler:function(){},nextHandler:function(){},goToPageHandler:function(){},accessibilityLabel:null,className:null,desiredNumberOfPages:5,isCompactMode:!1},c.displayName="Pagination",c.filename=__filename;var _=c;
//# sourceMappingURL=Pagination-faeb1642.js.map


/***/ }),

/***/ 11430:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[communityId]/events/[eventId]",
      function () {
        return __webpack_require__(1239);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42990);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1922);
/* harmony import */ var _AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16130);
/* harmony import */ var _AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var AdminOnlyIndicator = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx("admin-only-indicator"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx("admin-only-indicator__icon"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__.I, {
                    name: "eye"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx("admin-only-indicator__message"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: t("components-adminOnlyIndicator-info_message", "Only admins can see this")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdminOnlyIndicator);


/***/ }),

/***/ 11357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9973);




var CommunityHeader = function(param) {
    var pageTitle = param.pageTitle;
    var community = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__/* .useCommunityContext */ .v1)().community;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
            children: [
                pageTitle,
                " | ",
                community.name
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommunityHeader);


/***/ }),

/***/ 24159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1922);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90923);
/* harmony import */ var toga__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5370);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9973);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17981);
/* harmony import */ var utils_userHelpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73652);
/* harmony import */ var utils_routerHelpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4154);
/* harmony import */ var constants_featureFlags__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46139);
/* harmony import */ var components_Events_hooks_useEventInterest__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65699);
/* harmony import */ var components_SiteFeaturesContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40670);
/* harmony import */ var _EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64324);
/* harmony import */ var _EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14__);
















var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()));
var EventCard = function(param) {
    var id = param.id, title = param.title, imageUrl = param.imageUrl, imageAltText = param.imageAltText, startTime = param.startTime, endTime = param.endTime, timezone = param.timezone, isPreview = param.isPreview, interestedUserCount = param.interestedUserCount, isInterested = param.isInterested;
    var ref;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var ref1 = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_6__/* .useCommunityContext */ .v1)(), currentUser = ref1.currentUser, community = ref1.community, featureFlags = ref1.featureFlags;
    var siteFeatures = (0,components_SiteFeaturesContext__WEBPACK_IMPORTED_MODULE_13__/* .useSiteFeaturesContext */ .Er)().siteFeatures;
    var eventNotificationsEnabled = siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref = siteFeatures.communityEventNotifications) === null || ref === void 0 ? void 0 : ref.isEnabled;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref2 = (0,components_Events_hooks_useEventInterest__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(id), addInterest = ref2.addInterest, removeInterest = ref2.removeInterest, loading = ref2.loading;
    var rsvpEnabled = featureFlags[constants_featureFlags__WEBPACK_IMPORTED_MODULE_11__/* .features.COMMUNITIES_EVENTS_RSVP */ .R.COMMUNITIES_EVENTS_RSVP];
    var formattedDate = (0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .localeEventsDate */ .U0)(startTime, currentUser.locale, timezone);
    var getBadgeText = function() {
        if ((0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventLive */ .MF)(startTime, endTime)) return t("components-events-eventCard-live", "Live");
        if ((0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventStartingSoon */ .HE)(startTime, 15)) return t("components-events-eventCard-starting_soon", "Starting soon");
        return "";
    };
    var actions = [];
    var statusList = [];
    var isPastEvent = new Date() > new Date(endTime);
    if (rsvpEnabled && eventNotificationsEnabled && id) {
        if ((0,utils_userHelpers__WEBPACK_IMPORTED_MODULE_9__/* .isAdmin */ .GJ)(currentUser)) {
            actions.push({
                name: "Edit",
                text: t("common-EDIT", "EDIT"),
                onClick: function() {
                    (0,utils_routerHelpers__WEBPACK_IMPORTED_MODULE_10__/* .goToEditEvent */ .zf)(router, id, community.id);
                }
            });
            if (interestedUserCount) {
                statusList.push(t("components-events-interested_total", "{{total}} Interested", {
                    total: interestedUserCount
                }));
            }
        } else if (!isPastEvent) {
            if (isInterested) {
                // Interested Student
                actions.push({
                    name: "Remove Interest",
                    iconLeft: "minus",
                    text: t("components-events-eventCard-REMOVE_INTEREST", "REMOVE INTEREST"),
                    onClick: function() {
                        removeInterest();
                    }
                });
                if (interestedUserCount === 1) {
                    // There is only one interested student and it is you
                    statusList.push({
                        text: t("components-events-interested", "Interested"),
                        type: "active"
                    });
                } else if (interestedUserCount) {
                    // There are many interested including you
                    statusList.push({
                        text: t("components-events-you_and_others_interested", "You & {{total}} Interested", {
                            total: interestedUserCount - 1
                        }),
                        type: "active"
                    });
                }
            } else {
                // Student and they are not interested
                actions.push({
                    name: "Express Interest",
                    iconLeft: "plus",
                    text: t("components-events-eventCard-INTERESTED", "INTERESTED"),
                    onClick: function() {
                        addInterest();
                    }
                });
                if (interestedUserCount) {
                    statusList.push({
                        text: t("components-events-interested_total", "{{total}} Interested", {
                            total: interestedUserCount
                        }),
                        type: "inactive"
                    });
                }
            }
        }
    }
    var showFooter = !!actions.length;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(toga__WEBPACK_IMPORTED_MODULE_5__/* .Card */ .Zb, {
        badgeText: isPreview ? "" : getBadgeText(),
        badgeType: (0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventLive */ .MF)(startTime, endTime) ? "danger" : "success",
        caption: formattedDate,
        className: cx("event-card"),
        footerActions: showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_15__.I, {
            actions: actions,
            ariaLabel: t("components-events-eventCard-dropdown_aria_label", "Event Card Dropdown"),
            buttonAppearance: "knockout"
        }),
        image: imageUrl || utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .EVENT_IMAGE_PLACEHOLDER */ .dm,
        imageAlt: imageAltText || "",
        isDisabled: loading,
        name: title,
        statusList: statusList,
        invertedCaption: true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventCard);


/***/ }),

/***/ 93311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Dismissable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(6482);
;// CONCATENATED MODULE: ./components/HOCs/Dismissable/Dismissable.tsx






var withDismissable = function(BaseComponent, localStorageKey) {
    return function(_param) {
        var props = (0,_extends/* default */.Z)({}, _param);
        var ref = (0,useLocalStorage/* default */.Z)(localStorageKey), isSaved = ref.isSaved, saveKeyInLocalStorage = ref.saveKeyInLocalStorage;
        if (isSaved) return null;
        var onDismiss = function() {
            saveKeyInLocalStorage(true);
        };
        var dismissable = /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            onDismiss: onDismiss
        }));
        return dismissable;
    };
};

/* harmony default export */ var Dismissable = (withDismissable);

;// CONCATENATED MODULE: ./components/HOCs/Dismissable/index.ts



/***/ }),

/***/ 4069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InfoCard_InfoCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./components/Card/Card.module.scss
var Card_module = __webpack_require__(25079);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ./components/Card/Card.tsx




var cx = bind_default().bind((Card_module_default()));
var Card = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx("card"),
        children: children
    });
};
/* harmony default export */ var Card_Card = (Card);

;// CONCATENATED MODULE: ./components/Card/index.ts


// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(6482);
// EXTERNAL MODULE: ./components/InfoCard/InfoCard.module.scss
var InfoCard_module = __webpack_require__(4856);
var InfoCard_module_default = /*#__PURE__*/__webpack_require__.n(InfoCard_module);
;// CONCATENATED MODULE: ./components/InfoCard/InfoCard.tsx








var InfoCard_cx = bind_default().bind((InfoCard_module_default()));
var InfoCard = function(param) {
    var isDismissable = param.isDismissable, title = param.title, isCompact = param.isCompact, children = param.children, localStorageKey = param.localStorageKey, dataQA = param.dataQA, onClose = param.onClose, wrapper = param.wrapper;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,useLocalStorage/* default */.Z)(localStorageKey || ""), isSaved = ref.isSaved, saveKeyInLocalStorage = ref.saveKeyInLocalStorage;
    if (isDismissable && isSaved) return null;
    // If no localStorageKey is provided, then we know
    // that the component should be shown back if the user
    // refreshes/goes away and comes back to the page where
    // the section shown.
    var handleHideSection = function() {
        if (localStorageKey) saveKeyInLocalStorage(true);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var dismissButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
        appearance: "utility",
        className: InfoCard_cx("info-card__dismiss-button"),
        name: "x-dismiss",
        title: t("common-dismiss-empty-state", "Dismiss the {{title}} section", {
            title: title
        }),
        onClick: handleHideSection
    });
    var Wrapper = wrapper || Card_Card;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: InfoCard_cx("info-card", {
                "info-card--compact": isCompact
            }),
            "data-qa": dataQA,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: InfoCard_cx("info-card__dismiss-wrapper"),
                    children: isDismissable && dismissButton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: InfoCard_cx("info-card__header", {
                        "info-card__header--dismissable": isDismissable
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: InfoCard_cx("info-card__title", {
                            "info-card__title--compact": isCompact
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var InfoCard_InfoCard = (InfoCard);

;// CONCATENATED MODULE: ./components/InfoCard/index.ts



/***/ }),

/***/ 45784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ LocalStorageKeys; }
/* harmony export */ });
var LocalStorageKeys = {
    eventFormEmailNotificationUpsell: "thinkific.communities.eventFormEmailNotificationUpsell",
    eventsPageEmailNotificationUpsell: "thinkific.communities.eventsPageEmailNotificationUpsell",
    eventPageInterestedMembersUpsell: "thinkific.communities.eventPageInterestedMembersUpsell"
};


/***/ }),

/***/ 6482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useLocalStorage = function(localStorageKey) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!localStorage.getItem(localStorageKey)), isSaved = ref[0], setIsSaved = ref[1];
    var getKeyFromLocalStorage = function() {
        var value = localStorage.getItem(localStorageKey);
        if (value) return JSON.parse(value);
        return null;
    };
    var saveKeyInLocalStorage = function(value) {
        try {
            localStorage.setItem(localStorageKey, JSON.stringify(value));
            setIsSaved(true);
        } catch (e) {
            setIsSaved(false);
        }
    };
    var removeKeyFromLocalStorage = function() {
        try {
            localStorage.removeItem(localStorageKey);
            setIsSaved(false);
        } catch (e) {
            setIsSaved(true);
        }
    };
    return {
        isSaved: isSaved,
        getKeyFromLocalStorage: getKeyFromLocalStorage,
        removeKeyFromLocalStorage: removeKeyFromLocalStorage,
        saveKeyInLocalStorage: saveKeyInLocalStorage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLocalStorage);


/***/ }),

/***/ 72500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ EmptyState_EmptyState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./koba/components/EmptyState/EmptyState.module.scss
var EmptyState_module = __webpack_require__(13329);
var EmptyState_module_default = /*#__PURE__*/__webpack_require__.n(EmptyState_module);
;// CONCATENATED MODULE: ./koba/components/EmptyState/EmptyState.tsx





var cx = bind_default().bind((EmptyState_module_default()));
var EmptyState = function(param) {
    var actions = param.actions, className = param.className, _style = param.style, style = _style === void 0 ? {} : _style, title = param.title, titleClass = param.titleClass;
    var emptyStateClassNames = cx("empty-state", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: emptyStateClassNames,
        style: style,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H2, {
                className: cx("empty-state__title", titleClass),
                children: title
            }),
            actions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("empty-state__actions"),
                children: actions
            })
        ]
    });
};
/* harmony default export */ var EmptyState_EmptyState = (EmptyState);

;// CONCATENATED MODULE: ./koba/components/EmptyState/index.tsx



/***/ }),

/***/ 1239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EventPage": function() { return /* binding */ EventPage; },
  "default": function() { return /* binding */ _eventId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Row-ef6c768c.js
var Row_ef6c768c = __webpack_require__(93928);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Surface-649a6d6c.js
var Surface_649a6d6c = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./schema/Event/queries.ts
var queries = __webpack_require__(70564);
// EXTERNAL MODULE: ./toga/index.ts + 2 modules
var toga = __webpack_require__(5370);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/EmptyState/index.tsx + 1 modules
var EmptyState = __webpack_require__(72500);
// EXTERNAL MODULE: ./components/Image/index.ts + 1 modules
var Image = __webpack_require__(82513);
// EXTERNAL MODULE: ./components/PageSkeleton/index.ts + 1 modules
var PageSkeleton = __webpack_require__(62185);
// EXTERNAL MODULE: ./components/Events/components/EventPanel/components/EventContent/EventContent.tsx
var EventContent = __webpack_require__(56613);
// EXTERNAL MODULE: ./components/Events/components/EventPanel/components/EventInterestedButton/EventInterestedButton.tsx
var EventInterestedButton = __webpack_require__(75196);
// EXTERNAL MODULE: ./components/Events/components/EventPanel/components/EditEventButton/EditEventButton.tsx
var EditEventButton = __webpack_require__(45022);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/HOCs/Dismissable/index.ts + 1 modules
var Dismissable = __webpack_require__(93311);
// EXTERNAL MODULE: ./constants/localStorageKeys.ts
var localStorageKeys = __webpack_require__(45784);
// EXTERNAL MODULE: ./components/InfoCard/index.ts + 3 modules
var InfoCard = __webpack_require__(4069);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./components/Upsells/InterestedMembers/components/MiniUserDetail.module.scss
var MiniUserDetail_module = __webpack_require__(69594);
var MiniUserDetail_module_default = /*#__PURE__*/__webpack_require__.n(MiniUserDetail_module);
;// CONCATENATED MODULE: ./components/Upsells/InterestedMembers/components/MiniUserDetail.tsx






var cx = bind_default().bind((MiniUserDetail_module_default()));
var MiniUserDetail = function(param) {
    var userId = param.userId, username = param.username, avatar = param.avatar;
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("mini-user-detail"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                avatarUrl: avatar,
                className: cx("mini-user-detail__avatar"),
                size: "xs",
                userId: userId,
                username: username
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("mini-user-detail__label"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx("mini-user-detail__name"),
                        children: username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx("mini-user-detail__role"),
                        children: t("common-student", "Student")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_MiniUserDetail = (MiniUserDetail);

// EXTERNAL MODULE: ./components/Upsells/InterestedMembers/InterestedMembersUpsell.module.scss
var InterestedMembersUpsell_module = __webpack_require__(81068);
var InterestedMembersUpsell_module_default = /*#__PURE__*/__webpack_require__.n(InterestedMembersUpsell_module);
;// CONCATENATED MODULE: ./components/Upsells/InterestedMembers/InterestedMembersUpsell.tsx
















var InterestedMembersUpsell_cx = bind_default().bind((InterestedMembersUpsell_module_default()));
var UPGRADE_PROMPT_AVATAR_1 = "https://cdn.thinkific.com/90/20221129/773c20595e78c081f9a1b42ce2892530.png";
var UPGRADE_PROMPT_AVATAR_2 = "https://cdn.thinkific.com/90/20221129/aaef1d4088f619886e9fc1f98d06e511.png";
var InterestedMembersUpsell = function(param) {
    var onDismiss = param.onDismiss;
    var t = (0,es/* useTranslation */.$G)().t;
    var trackEvent = (0,CommunityContext/* useCommunityContext */.v1)().trackEvent;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* SCREEN_LG */.k4;
    var onClick = function(event) {
        event.preventDefault();
        trackEvent(trackingEvents/* default.CLICK_UPGRADE_SUBSCRIPTION_LINK */.ZP.CLICK_UPGRADE_SUBSCRIPTION_LINK, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "InterestedMembersUpsell"));
        window.open(routerHelpers/* routes.subscription */._j.subscription, "_blank");
    };
    var CustomWrapper = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: InterestedMembersUpsell_cx("interested-members-upsell-wrapper"),
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: InterestedMembersUpsell_cx("interested-members-upsell", "mb-2"),
        "data-qa": "interested-members-upsell",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoCard/* default */.Z, {
            title: t("components-interestedMembersUpsell-title", "Interested Members"),
            wrapper: CustomWrapper,
            isCompact: true,
            isDismissable: true,
            onClose: onDismiss,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("components-interestedMembersUpsell-upgrade_prompt_call_to_action", "Upgrade to track event RSVPs and email members about event updates.")
                }),
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MiniUserDetail, {
                            avatar: UPGRADE_PROMPT_AVATAR_1,
                            userId: "1",
                            username: "Courtney Henry"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MiniUserDetail, {
                            avatar: "",
                            userId: "2",
                            username: "Diane Russel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MiniUserDetail, {
                            avatar: UPGRADE_PROMPT_AVATAR_2,
                            userId: "3",
                            username: "Ronald Richards"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: InterestedMembersUpsell_cx("mt-2"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
                        appearance: "primary",
                        className: InterestedMembersUpsell_cx("upgrade-prompt__upgrade-button"),
                        isUpgrade: true,
                        onClick: onClick,
                        children: t("components-interestedMembersUpsell-upgrade_button", "UPGRADE NOW")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var InterestedMembers_InterestedMembersUpsell = ((0,Dismissable/* default */.Z)(InterestedMembersUpsell, localStorageKeys/* LocalStorageKeys.eventPageInterestedMembersUpsell */.d.eventPageInterestedMembersUpsell));

;// CONCATENATED MODULE: ./components/Upsells/InterestedMembers/index.ts


// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Loader-fe940c7c.js
var Loader_fe940c7c = __webpack_require__(75826);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Pagination-faeb1642.js
var Pagination_faeb1642 = __webpack_require__(20145);
// EXTERNAL MODULE: ./utils/paginationHelpers.ts
var paginationHelpers = __webpack_require__(91405);
// EXTERNAL MODULE: ./components/Events/components/EventInterestedUsersList/EventInterestedUsersList.module.scss
var EventInterestedUsersList_module = __webpack_require__(52122);
var EventInterestedUsersList_module_default = /*#__PURE__*/__webpack_require__.n(EventInterestedUsersList_module);
;// CONCATENATED MODULE: ./components/Events/components/EventInterestedUsersList/EventInterestedUsersList.tsx









var EventInterestedUsersList_cx = bind_default().bind((EventInterestedUsersList_module_default()));
var EventInterestedUsersList = function(param) {
    var totalInterestedUsers = param.totalInterestedUsers, interestedUsersEdges = param.interestedUsersEdges, setEndCursor = param.setEndCursor, isLoading = param.isLoading;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(1), userPage = ref[0], setUserPage = ref[1];
    var totalUserPages = (0,paginationHelpers/* getTotalPages */.g)(totalInterestedUsers || 0, constants/* NUMBER_OF_INTERESTED_USERS_ON_EVENT */.g2);
    var goToPage = function(page) {
        var after = btoa("".concat((page - 1) * constants/* NUMBER_OF_INTERESTED_USERS_ON_EVENT */.g2));
        setEndCursor(after);
        setUserPage(page);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                accessibilityLabel: t("common-loading", "Loading")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: EventInterestedUsersList_cx("event-interested-users-list__interested-users"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("common-interested", "Interested ({{total}})", {
                            total: totalInterestedUsers
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: interestedUsersEdges === null || interestedUsersEdges === void 0 ? void 0 : interestedUsersEdges.map(function(edge) {
                            var user = edge === null || edge === void 0 ? void 0 : edge.node;
                            if (user) {
                                var ref, ref1, ref2, ref3;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: EventInterestedUsersList_cx("event-interested-users-list__interested-user"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                                            avatarUrl: (ref = user.profile) === null || ref === void 0 ? void 0 : ref.avatarUrl,
                                            className: EventInterestedUsersList_cx("event-interested-users-list__interested-user-avatar"),
                                            size: "xs",
                                            srcSet: "".concat((ref1 = user.profile) === null || ref1 === void 0 ? void 0 : ref1.avatarUrl, "?width=40 1x, ").concat((ref2 = user.profile) === null || ref2 === void 0 ? void 0 : ref2.avatarUrl, "?width=40&dpr=2 2x, ").concat((ref3 = user.profile) === null || ref3 === void 0 ? void 0 : ref3.avatarUrl, "?width=40&dpr=3 3x"),
                                            userId: user.id,
                                            username: user.fullName || "",
                                            shouldOpenProfile: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            title: user.fullName || "",
                                            children: user.fullName
                                        })
                                    ]
                                }, user.id);
                            }
                            return null;
                        })
                    }),
                    totalUserPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_faeb1642.P, {
                        className: EventInterestedUsersList_cx("event-interested-users-list__interested-users-pagination"),
                        currentPage: userPage,
                        goTofirstHandler: function() {
                            return goToPage(1);
                        },
                        goTolastHandler: function() {
                            return goToPage(totalUserPages);
                        },
                        goToPageHandler: goToPage,
                        nextHandler: function() {
                            return goToPage(userPage + 1);
                        },
                        previousHandler: function() {
                            return goToPage(userPage - 1);
                        },
                        totalPages: totalUserPages
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EventInterestedUsersList_EventInterestedUsersList = (EventInterestedUsersList);

// EXTERNAL MODULE: ./components/Events/components/UpcomingEvents/index.ts + 4 modules
var UpcomingEvents = __webpack_require__(30899);
// EXTERNAL MODULE: ./components/CommunityHeader/CommunityHeader.tsx
var CommunityHeader = __webpack_require__(11357);
// EXTERNAL MODULE: ./components/VisibilityHelpers/FeatureCloak/index.ts + 1 modules
var FeatureCloak = __webpack_require__(72353);
// EXTERNAL MODULE: ./node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__(99490);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./components/SiteFeaturesContext/index.ts + 2 modules
var SiteFeaturesContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./pages/[communityId]/events/[eventId]/index.module.scss
var index_module = __webpack_require__(87955);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./pages/[communityId]/events/[eventId]/index.tsx






























var _eventId_cx = bind_default().bind((index_module_default()));
var EventPage = function() {
    var ref, ref1, ref2;
    var ref3 = (0,CommunityContext/* useCommunityContext */.v1)(), currentUser = ref3.currentUser, community = ref3.community, featureFlags = ref3.featureFlags, trackEvent = ref3.trackEvent;
    var siteFeatures = (0,SiteFeaturesContext/* useSiteFeaturesContext */.Er)().siteFeatures;
    var eventNotificationsEnabled = siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref = siteFeatures.communityEventNotifications) === null || ref === void 0 ? void 0 : ref.isEnabled;
    var rsvpEnabled = featureFlags[constants_featureFlags/* features.COMMUNITIES_EVENTS_RSVP */.R.COMMUNITIES_EVENTS_RSVP];
    var t = (0,es/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var _query = router.query, eventId = _query.eventId, canUseBrowserBack = _query.canUseBrowserBack;
    var ref4 = (0,react.useState)(false), hideOtherEventsColumn = ref4[0], setHideOtherEventsColumn = ref4[1];
    var ref5 = (0,react.useState)(""), endCursor = ref5[0], setEndCursor = ref5[1];
    var ref6 = (0,react.useState)(true), isValidURL = ref6[0], setIsValidURL = ref6[1];
    var ref7 = (0,useQuery/* useQuery */.a)(queries/* LIVE_EVENT_QUERY */.U7, {
        variables: {
            eventId: eventId,
            numberOfUsers: constants/* NUMBER_OF_INTERESTED_USERS_ON_EVENT */.g2,
            endCursor: endCursor
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "cache-and-network",
        skip: !eventId,
        onError: function() {
            setIsValidURL(false);
        }
    }), data = ref7.data, loading = ref7.loading, previousData = ref7.previousData;
    var event = data === null || data === void 0 ? void 0 : (ref1 = data.site) === null || ref1 === void 0 ? void 0 : ref1.liveEvent;
    var interestedUsers = (event === null || event === void 0 ? void 0 : event.interestedUsers) || (previousData === null || previousData === void 0 ? void 0 : (ref2 = previousData.site) === null || ref2 === void 0 ? void 0 : ref2.liveEvent.interestedUsers);
    var endTime = luxon/* DateTime.fromISO */.ou.fromISO((event === null || event === void 0 ? void 0 : event.endTime) || "");
    var isPastEvent = luxon/* DateTime.now */.ou.now() > endTime;
    var head = /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityHeader/* default */.Z, {
        pageTitle: t("pages-event_page", "Event {{eventTitle}}", {
            eventTitle: event === null || event === void 0 ? void 0 : event.title
        })
    });
    if (loading && !previousData) {
        // TODO: Create Skeleton for EventPage
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                head,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSkeleton/* default */.Z, {}),
                ";"
            ]
        });
    }
    var handleBackButton = function() {
        if (canUseBrowserBack) {
            router.back();
        } else {
            (0,routerHelpers/* goToHome */.rC)(router, community.id);
        }
    };
    var showEditButton = (0,userHelpers/* isAdmin */.GJ)(currentUser);
    var showEventInterestedButton = !(0,userHelpers/* isAdmin */.GJ)(currentUser) && !isPastEvent && rsvpEnabled && eventNotificationsEnabled && event; // Show event interest if they are a student, the event is upcoming, RSVP flag is enabled, and communityEventNotifications is enabled
    var hideEventColumn = !(0,userHelpers/* isAdmin */.GJ)(currentUser) && (!rsvpEnabled || !eventNotificationsEnabled); // Hide the event column if the user is a student, and either RSVP flag or communityEventNotifications is disabled
    var innerCol = hideEventColumn ? 12 : 8;
    var goToEventsPage = function() {
        trackEvent(trackingEvents/* default.CLICK_SEE_ALL_EVENTS */.ZP.CLICK_SEE_ALL_EVENTS);
        (0,routerHelpers/* goToEvents */.MW)(router, community.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            head,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: _eventId_cx("event-page__container"),
                children: [
                    window.innerWidth > constants/* BREAKPOINT_MD */.GI && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* ButtonWithIconLeft */.ej, {
                        appearance: "knockout",
                        className: _eventId_cx("button__breadcrumb"),
                        onClick: handleBackButton,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                name: "arrow-left"
                            }),
                            t("common-BACK", "BACK")
                        ]
                    }),
                    isValidURL ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_ef6c768c.R, {
                        className: _eventId_cx("event-page__wrapper"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(toga/* Col */.JX, {
                                lgColumns: 8,
                                mdColumns: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Surface_649a6d6c.S, {
                                    className: _eventId_cx("event-page__event-details"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_ef6c768c.R, {
                                        className: _eventId_cx("event-page__event-details-row"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(toga/* Col */.JX, {
                                                className: _eventId_cx("event-page__event-details-col"),
                                                lgColumns: innerCol,
                                                mdColumns: innerCol,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: (event === null || event === void 0 ? void 0 : event.imageAltText) || "",
                                                        className: _eventId_cx("event-page__image"),
                                                        height: 250,
                                                        src: (event === null || event === void 0 ? void 0 : event.imageUrl) || constants/* EVENT_IMAGE_PLACEHOLDER */.dm,
                                                        width: 465
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: _eventId_cx("event-page__content"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                children: event === null || event === void 0 ? void 0 : event.title
                                                            }),
                                                            event && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContent/* default */.Z, {
                                                                event: event,
                                                                parentComponent: "EventPage"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !hideEventColumn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(toga/* Col */.JX, {
                                                className: _eventId_cx("event-page__event-details-col", "event-page__event-details-users-col"),
                                                lgColumns: 4,
                                                mdColumns: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: _eventId_cx("event-page__action-buttons"),
                                                        children: [
                                                            showEditButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditEventButton/* default */.Z, {
                                                                className: "full-width",
                                                                eventId: (event === null || event === void 0 ? void 0 : event.id) || "",
                                                                parentComponent: "EventPage",
                                                                title: t("common-EDIT_EVENT", "EDIT EVENT"),
                                                                hasIcon: true
                                                            }),
                                                            showEventInterestedButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInterestedButton/* default */.Z, {
                                                                eventId: event === null || event === void 0 ? void 0 : event.id,
                                                                isDisabled: loading,
                                                                isInterested: (event === null || event === void 0 ? void 0 : event.isInterested) || false
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCloak/* default */.Z, {
                                                        communityEventNotifications: false,
                                                        flags: [
                                                            constants_featureFlags/* features.COMMUNITIES_EVENTS_RSVP */.R.COMMUNITIES_EVENTS_RSVP,
                                                            constants_featureFlags/* features.COMMUNITIES_EVENT_EMAILS */.R.COMMUNITIES_EVENT_EMAILS, 
                                                        ],
                                                        admins: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: _eventId_cx("event-page__upsell-container"),
                                                            "data-qa": "event_page__upsell-container",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InterestedMembers_InterestedMembersUpsell, {})
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCloak/* default */.Z, {
                                                        flags: [
                                                            constants_featureFlags/* features.COMMUNITIES_EVENTS_RSVP */.R.COMMUNITIES_EVENTS_RSVP
                                                        ],
                                                        communityEventNotifications: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInterestedUsersList_EventInterestedUsersList, {
                                                            interestedUsersEdges: interestedUsers === null || interestedUsers === void 0 ? void 0 : interestedUsers.edges,
                                                            isLoading: loading,
                                                            setEndCursor: setEndCursor,
                                                            totalInterestedUsers: interestedUsers === null || interestedUsers === void 0 ? void 0 : interestedUsers.totalCount
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            !hideOtherEventsColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCloak/* default */.Z, {
                                communityEvents: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(toga/* Col */.JX, {
                                    className: _eventId_cx("event-page__other_events-col"),
                                    lgColumns: 4,
                                    mdColumns: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: t("pages-events-other_upcoming_events", "Other upcoming events")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UpcomingEvents/* default */.Z, {
                                            numberOfEvents: 3,
                                            setHideComponent: setHideOtherEventsColumn,
                                            shouldDisplayHeader: false
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: _eventId_cx("event-page__empty-state"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* default */.Z, {
                            actions: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                    appearance: "default",
                                    color: community.primaryColor,
                                    dataQA: "see-all-events__button",
                                    onClick: goToEventsPage,
                                    children: t("pages-events-see_all_events", "See All Events")
                                }, "1"), 
                            ],
                            className: "event-page__full-width",
                            title: t("pages-events-event_not_found", "Event not found")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _eventId_ = (EventPage);


/***/ }),

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N9": function() { return /* binding */ OrderDirection; },
/* harmony export */   "d3": function() { return /* binding */ PostOrderField; },
/* harmony export */   "t": function() { return /* binding */ EventStatusTypes; }
/* harmony export */ });
/* unused harmony exports AccountNotificationSlugType, PostAttachmentType, PostReactionType */
var AccountNotificationSlugType;
(function(AccountNotificationSlugType) {
    AccountNotificationSlugType["community_post_reply"] = "community_post_reply";
})(AccountNotificationSlugType || (AccountNotificationSlugType = {}));
var EventStatusTypes;
(function(EventStatusTypes) {
    EventStatusTypes["EXPIRED"] = "EXPIRED";
    EventStatusTypes["UPCOMING"] = "UPCOMING";
})(EventStatusTypes || (EventStatusTypes = {}));
var OrderDirection;
(function(OrderDirection) {
    OrderDirection["ASC"] = "ASC";
    OrderDirection["DESC"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
var PostAttachmentType;
(function(PostAttachmentType) {
    PostAttachmentType["file"] = "file";
    PostAttachmentType["image"] = "image";
    PostAttachmentType["video"] = "video";
})(PostAttachmentType || (PostAttachmentType = {}));
var PostOrderField;
(function(PostOrderField) {
    PostOrderField["CONTENT_NAME"] = "CONTENT_NAME";
    PostOrderField["COURSE_NAME"] = "COURSE_NAME";
    PostOrderField["CREATED_AT"] = "CREATED_AT";
    PostOrderField["LAST_INTERACTION_AT"] = "LAST_INTERACTION_AT";
    PostOrderField["PINNED_AT"] = "PINNED_AT";
    PostOrderField["REPLY_COUNT"] = "REPLY_COUNT";
    PostOrderField["TITLE"] = "TITLE";
    PostOrderField["TRENDING_SCORE"] = "TRENDING_SCORE";
    PostOrderField["UPDATED_AT"] = "UPDATED_AT";
})(PostOrderField || (PostOrderField = {}));
var PostReactionType;
(function(PostReactionType) {
    PostReactionType["like"] = "like";
})(PostReactionType || (PostReactionType = {}));


/***/ }),

/***/ 23077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ togaFooterBlockName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div[class*='footer'] {\n    box-sizing: border-box;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var togaFooterBlockName = "card__footer";
// Toga's react version of this card is missing border-box 🙃
// Card footers render twice as large without it
var wrapped = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_2__.C)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (wrapped);


/***/ }),

/***/ 5370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zb": function() { return /* reexport */ Card/* default */.Z; },
  "JX": function() { return /* reexport */ Col; },
  "W2": function() { return /* reexport */ Container; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Row-ef6c768c.js
var Row_ef6c768c = __webpack_require__(93928);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./toga/Container.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var wrapped = (0,styled_components_browser_esm/* default */.ZP)(Row_ef6c768c.C)(_templateObject());
/* harmony default export */ var Container = (wrapped);

;// CONCATENATED MODULE: ./toga/Col.tsx

function Col_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n"
    ]);
    Col_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Col_wrapped = (0,styled_components_browser_esm/* default */.ZP)(Row_ef6c768c.a)(Col_templateObject());
/* harmony default export */ var Col = (Col_wrapped);

// EXTERNAL MODULE: ./toga/Card.tsx
var Card = __webpack_require__(23077);
;// CONCATENATED MODULE: ./toga/index.ts






/***/ }),

/***/ 91405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ parseCursor; },
/* harmony export */   "g": function() { return /* binding */ getTotalPages; }
/* harmony export */ });
var parseCursor = function(cursor) {
    return cursor ? parseInt(window.atob(cursor), 10) : null;
};
var getTotalPages = function(totalCount, limit) {
    return Math.max(Math.ceil(totalCount / limit) || 1);
};


/***/ }),

/***/ 16130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"AdminOnlyIndicator_sr-only--mobile__V_O5h","sr-only":"AdminOnlyIndicator_sr-only__qudiG","error-message":"AdminOnlyIndicator_error-message__o6_Mk","form-inline-edit":"AdminOnlyIndicator_form-inline-edit__1rOMu","form-group":"AdminOnlyIndicator_form-group__P_zKT","form-row":"AdminOnlyIndicator_form-row__EzBE2","form-inline":"AdminOnlyIndicator_form-inline__NoKeJ","error":"AdminOnlyIndicator_error__DTNfK","input-group-append":"AdminOnlyIndicator_input-group-append__lhDS3","input-group-currency":"AdminOnlyIndicator_input-group-currency__0zgWg","form-control":"AdminOnlyIndicator_form-control__7nBF_","custom-select":"AdminOnlyIndicator_custom-select__wW7Y_","is-invalid":"AdminOnlyIndicator_is-invalid__xLyF6","is-valid":"AdminOnlyIndicator_is-valid__3bhop","input-group":"AdminOnlyIndicator_input-group__th3eH","input-group-text":"AdminOnlyIndicator_input-group-text__HXMCd","input-group-prepend":"AdminOnlyIndicator_input-group-prepend__xd9BQ","valid-feedback":"AdminOnlyIndicator_valid-feedback__3RqVS","invalid-feedback":"AdminOnlyIndicator_invalid-feedback__vVLXV","form-text":"AdminOnlyIndicator_form-text__EMwMA","label":"AdminOnlyIndicator_label__htcqJ","custom-control":"AdminOnlyIndicator_custom-control__n1VIY","custom-control-label":"AdminOnlyIndicator_custom-control-label__FAv4l","custom-control-label--empty":"AdminOnlyIndicator_custom-control-label--empty__aMFmr","custom-control-input":"AdminOnlyIndicator_custom-control-input__TrqAO","admin-only-indicator":"AdminOnlyIndicator_admin-only-indicator__mMTxj","admin-only-indicator__icon":"AdminOnlyIndicator_admin-only-indicator__icon__Ly9X8","admin-only-indicator__message":"AdminOnlyIndicator_admin-only-indicator__message__c98W5"};

/***/ }),

/***/ 25079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Card_sr-only--mobile__pyBUz","sr-only":"Card_sr-only__SIhMy","error-message":"Card_error-message__yZHay","form-inline-edit":"Card_form-inline-edit__O7lAa","form-group":"Card_form-group__6a19M","form-row":"Card_form-row__GyjgV","form-inline":"Card_form-inline__JC07O","error":"Card_error__AZsoV","input-group-append":"Card_input-group-append__4S9l1","input-group-currency":"Card_input-group-currency__cBLyv","form-control":"Card_form-control__FKUhb","custom-select":"Card_custom-select__wAwyN","is-invalid":"Card_is-invalid__mruvn","is-valid":"Card_is-valid__6nnKW","input-group":"Card_input-group__ZVE3x","input-group-text":"Card_input-group-text__JjRPi","input-group-prepend":"Card_input-group-prepend__4FTVF","valid-feedback":"Card_valid-feedback__LJdLl","invalid-feedback":"Card_invalid-feedback__tZSON","form-text":"Card_form-text__t8Ua4","label":"Card_label__sW6BW","custom-control":"Card_custom-control__r_5XG","custom-control-label":"Card_custom-control-label__g1TZ4","custom-control-label--empty":"Card_custom-control-label--empty__zEhvd","custom-control-input":"Card_custom-control-input__7ePj9","card":"Card_card__pfJM5"};

/***/ }),

/***/ 64324:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"event-card":"EventCard_event-card__vqeTZ","event-card__title":"EventCard_event-card__title__RgU1t"};

/***/ }),

/***/ 52122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EventInterestedUsersList_sr-only--mobile__ZBVWR","sr-only":"EventInterestedUsersList_sr-only__VJKyC","error-message":"EventInterestedUsersList_error-message__UO2hb","form-inline-edit":"EventInterestedUsersList_form-inline-edit__vbF_Z","form-group":"EventInterestedUsersList_form-group__xXJLx","form-row":"EventInterestedUsersList_form-row__eP_2a","form-inline":"EventInterestedUsersList_form-inline__HYXbh","error":"EventInterestedUsersList_error__ZpN08","input-group-append":"EventInterestedUsersList_input-group-append__L2ogf","input-group-currency":"EventInterestedUsersList_input-group-currency__rIS3_","form-control":"EventInterestedUsersList_form-control__gaCnY","custom-select":"EventInterestedUsersList_custom-select__z7Q5K","is-invalid":"EventInterestedUsersList_is-invalid__2fMAx","is-valid":"EventInterestedUsersList_is-valid__dtFdV","input-group":"EventInterestedUsersList_input-group__OOl3R","input-group-text":"EventInterestedUsersList_input-group-text__H6KHl","input-group-prepend":"EventInterestedUsersList_input-group-prepend__1dh_u","valid-feedback":"EventInterestedUsersList_valid-feedback__0ibPK","invalid-feedback":"EventInterestedUsersList_invalid-feedback__R57qk","form-text":"EventInterestedUsersList_form-text__nMyQz","label":"EventInterestedUsersList_label__l8JYp","custom-control":"EventInterestedUsersList_custom-control__OJiNE","custom-control-label":"EventInterestedUsersList_custom-control-label__ksFOT","custom-control-label--empty":"EventInterestedUsersList_custom-control-label--empty__HQnZH","custom-control-input":"EventInterestedUsersList_custom-control-input__kLWgL","h1":"EventInterestedUsersList_h1__eqsaG","h2":"EventInterestedUsersList_h2__bonhT","h3":"EventInterestedUsersList_h3__VUxxP","h4":"EventInterestedUsersList_h4__4UOow","p":"EventInterestedUsersList_p___R1fi","caption":"EventInterestedUsersList_caption__xb_eV","mx-3":"EventInterestedUsersList_mx-3__zv4Ke","mb-1":"EventInterestedUsersList_mb-1__D17fd","mb-2":"EventInterestedUsersList_mb-2__FzWjb","mb-3":"EventInterestedUsersList_mb-3__Yi2Ju","mb-4":"EventInterestedUsersList_mb-4__b5fGS","mb-5":"EventInterestedUsersList_mb-5__0LB64","mt-2":"EventInterestedUsersList_mt-2__rib7l","ml-1":"EventInterestedUsersList_ml-1__duZwN","p-2":"EventInterestedUsersList_p-2__zpcfU","p-3":"EventInterestedUsersList_p-3__iaqK_","border-box":"EventInterestedUsersList_border-box__jFdXs","d-inline-block":"EventInterestedUsersList_d-inline-block__8lDiH","event-interested-users-list__interested-users":"EventInterestedUsersList_event-interested-users-list__interested-users__OIhRN","event-interested-users-list__interested-users-pagination":"EventInterestedUsersList_event-interested-users-list__interested-users-pagination__2blCv","event-interested-users-list__content":"EventInterestedUsersList_event-interested-users-list__content__kbjIg","event-interested-users-list__interested-user":"EventInterestedUsersList_event-interested-users-list__interested-user__VO7Jv","event-interested-users-list__interested-user-avatar":"EventInterestedUsersList_event-interested-users-list__interested-user-avatar__oX8HT"};

/***/ }),

/***/ 4856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"InfoCard_sr-only--mobile__i601v","sr-only":"InfoCard_sr-only__vL_gU","error-message":"InfoCard_error-message__c92GS","form-inline-edit":"InfoCard_form-inline-edit__TJwoX","form-group":"InfoCard_form-group__keMqm","form-row":"InfoCard_form-row__Qyw2B","form-inline":"InfoCard_form-inline__jbZ4A","error":"InfoCard_error__YP2_l","input-group-append":"InfoCard_input-group-append___EsaJ","input-group-currency":"InfoCard_input-group-currency__aO0mN","form-control":"InfoCard_form-control__sVJ7H","custom-select":"InfoCard_custom-select__Biz3h","is-invalid":"InfoCard_is-invalid__CfhOh","is-valid":"InfoCard_is-valid__dLrJq","input-group":"InfoCard_input-group__xgz5V","input-group-text":"InfoCard_input-group-text__w0tjr","input-group-prepend":"InfoCard_input-group-prepend__K0SE5","valid-feedback":"InfoCard_valid-feedback__fFNYh","invalid-feedback":"InfoCard_invalid-feedback__ej2M8","form-text":"InfoCard_form-text__2NXrk","label":"InfoCard_label__NAJgQ","custom-control":"InfoCard_custom-control___On2o","custom-control-label":"InfoCard_custom-control-label__LEWoW","custom-control-label--empty":"InfoCard_custom-control-label--empty__iiBN4","custom-control-input":"InfoCard_custom-control-input__yntTp","info-card":"InfoCard_info-card__ygNJi","info-card--compact":"InfoCard_info-card--compact__j4bx7","info-card__header":"InfoCard_info-card__header__g_F2p","info-card__header--dismissable":"InfoCard_info-card__header--dismissable__TNoXX","info-card__title":"InfoCard_info-card__title__rzlR1","info-card__title--compact":"InfoCard_info-card__title--compact__rq0x8","info-card__dismiss-wrapper":"InfoCard_info-card__dismiss-wrapper__ESdSm"};

/***/ }),

/***/ 81068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"InterestedMembersUpsell_sr-only--mobile__QRhhe","sr-only":"InterestedMembersUpsell_sr-only__oIIiI","error-message":"InterestedMembersUpsell_error-message__txNnX","form-inline-edit":"InterestedMembersUpsell_form-inline-edit__TDwmk","form-group":"InterestedMembersUpsell_form-group__wHxHO","form-row":"InterestedMembersUpsell_form-row__BEzpB","form-inline":"InterestedMembersUpsell_form-inline__UD1zw","error":"InterestedMembersUpsell_error__X7wIb","input-group-append":"InterestedMembersUpsell_input-group-append__InrX3","input-group-currency":"InterestedMembersUpsell_input-group-currency__yE6o_","form-control":"InterestedMembersUpsell_form-control__8MVqA","custom-select":"InterestedMembersUpsell_custom-select__7K_Et","is-invalid":"InterestedMembersUpsell_is-invalid__v1o5G","is-valid":"InterestedMembersUpsell_is-valid__yhC6V","input-group":"InterestedMembersUpsell_input-group__PxOIj","input-group-text":"InterestedMembersUpsell_input-group-text__qTSJE","input-group-prepend":"InterestedMembersUpsell_input-group-prepend__NxN5E","valid-feedback":"InterestedMembersUpsell_valid-feedback__FZk6z","invalid-feedback":"InterestedMembersUpsell_invalid-feedback__fHopT","form-text":"InterestedMembersUpsell_form-text__F_Rds","label":"InterestedMembersUpsell_label__upQyn","custom-control":"InterestedMembersUpsell_custom-control__JBtdq","custom-control-label":"InterestedMembersUpsell_custom-control-label__NBCZq","custom-control-label--empty":"InterestedMembersUpsell_custom-control-label--empty__kGFGU","custom-control-input":"InterestedMembersUpsell_custom-control-input__gaTLW","mx-3":"InterestedMembersUpsell_mx-3__MWa7_","mb-1":"InterestedMembersUpsell_mb-1__e8gId","mb-2":"InterestedMembersUpsell_mb-2__be3Rp","mb-3":"InterestedMembersUpsell_mb-3__b8ibS","mb-4":"InterestedMembersUpsell_mb-4__KRcwE","mb-5":"InterestedMembersUpsell_mb-5__ggkHS","mt-2":"InterestedMembersUpsell_mt-2__NBNjn","ml-1":"InterestedMembersUpsell_ml-1__x2YS8","p-2":"InterestedMembersUpsell_p-2__Ze_NW","p-3":"InterestedMembersUpsell_p-3__cpNp8","border-box":"InterestedMembersUpsell_border-box__bmJcj","d-inline-block":"InterestedMembersUpsell_d-inline-block__RFWbI","interested-members-upsell-wrapper":"InterestedMembersUpsell_interested-members-upsell-wrapper__p9ONR"};

/***/ }),

/***/ 69594:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MiniUserDetail_sr-only--mobile__FDBRD","sr-only":"MiniUserDetail_sr-only__BO8Sf","error-message":"MiniUserDetail_error-message__WIw0B","form-inline-edit":"MiniUserDetail_form-inline-edit__EfTM3","form-group":"MiniUserDetail_form-group__wYv9R","form-row":"MiniUserDetail_form-row__adGwF","form-inline":"MiniUserDetail_form-inline__RPCfa","error":"MiniUserDetail_error__8eHEE","input-group-append":"MiniUserDetail_input-group-append__WW8_W","input-group-currency":"MiniUserDetail_input-group-currency__pRpia","form-control":"MiniUserDetail_form-control__7s56z","custom-select":"MiniUserDetail_custom-select__PvG_O","is-invalid":"MiniUserDetail_is-invalid__lIFc4","is-valid":"MiniUserDetail_is-valid__UorjB","input-group":"MiniUserDetail_input-group__egLlW","input-group-text":"MiniUserDetail_input-group-text__4Bg7A","input-group-prepend":"MiniUserDetail_input-group-prepend__2orAT","valid-feedback":"MiniUserDetail_valid-feedback__R_S_Y","invalid-feedback":"MiniUserDetail_invalid-feedback___mVgH","form-text":"MiniUserDetail_form-text__7o3Ro","label":"MiniUserDetail_label__hCWjC","custom-control":"MiniUserDetail_custom-control__KzL1K","custom-control-label":"MiniUserDetail_custom-control-label__Fos8p","custom-control-label--empty":"MiniUserDetail_custom-control-label--empty__yaqDl","custom-control-input":"MiniUserDetail_custom-control-input___cdmQ","mini-user-detail":"MiniUserDetail_mini-user-detail__MLqdd","mini-user-detail__label":"MiniUserDetail_mini-user-detail__label__pUx4m","mini-user-detail__name":"MiniUserDetail_mini-user-detail__name__2drPm","mini-user-detail__role":"MiniUserDetail_mini-user-detail__role__1RB01"};

/***/ }),

/***/ 13329:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EmptyState_sr-only--mobile__AXD6a","sr-only":"EmptyState_sr-only__WfBEe","error-message":"EmptyState_error-message__DZ_v_","form-inline-edit":"EmptyState_form-inline-edit__CJrXl","form-group":"EmptyState_form-group__Bf9ox","form-row":"EmptyState_form-row__a_lnO","form-inline":"EmptyState_form-inline__LFw6b","error":"EmptyState_error__vDGwn","input-group-append":"EmptyState_input-group-append__fiuHO","input-group-currency":"EmptyState_input-group-currency__GL8_G","form-control":"EmptyState_form-control__KZPS9","custom-select":"EmptyState_custom-select__HDx5W","is-invalid":"EmptyState_is-invalid__nak7A","is-valid":"EmptyState_is-valid__im6cU","input-group":"EmptyState_input-group__qB_sZ","input-group-text":"EmptyState_input-group-text__DZOuK","input-group-prepend":"EmptyState_input-group-prepend__P1crH","valid-feedback":"EmptyState_valid-feedback__SobLJ","invalid-feedback":"EmptyState_invalid-feedback__lvHne","form-text":"EmptyState_form-text__E2iOO","label":"EmptyState_label__FWN94","custom-control":"EmptyState_custom-control__BquI_","custom-control-label":"EmptyState_custom-control-label__T5YrP","custom-control-label--empty":"EmptyState_custom-control-label--empty__Iu4F4","custom-control-input":"EmptyState_custom-control-input__7qCR3","empty-state":"EmptyState_empty-state__FRtXr","empty-state__title":"EmptyState_empty-state__title__AsLRC","empty-state--full-width":"EmptyState_empty-state--full-width__szXLJ"};

/***/ }),

/***/ 87955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"_eventId__sr-only--mobile__YkKoE","sr-only":"_eventId__sr-only__wyLcM","error-message":"_eventId__error-message__mC10u","form-inline-edit":"_eventId__form-inline-edit__53iuV","form-group":"_eventId__form-group__C2xUL","form-row":"_eventId__form-row__qSX6V","form-inline":"_eventId__form-inline__hn0hp","error":"_eventId__error__IyyyI","input-group-append":"_eventId__input-group-append___irPr","input-group-currency":"_eventId__input-group-currency__g9Bkg","form-control":"_eventId__form-control__M4N1H","custom-select":"_eventId__custom-select__EmFOb","is-invalid":"_eventId__is-invalid__HX1y1","is-valid":"_eventId__is-valid__j9_hW","input-group":"_eventId__input-group__Zyhzw","input-group-text":"_eventId__input-group-text__3_Idi","input-group-prepend":"_eventId__input-group-prepend__dQrr4","valid-feedback":"_eventId__valid-feedback__IBWAA","invalid-feedback":"_eventId__invalid-feedback__5amZf","form-text":"_eventId__form-text__1SUXr","label":"_eventId__label__KFBZa","custom-control":"_eventId__custom-control__6wUGg","custom-control-label":"_eventId__custom-control-label__6uSGO","custom-control-label--empty":"_eventId__custom-control-label--empty__uXYjS","custom-control-input":"_eventId__custom-control-input__Os6pP","h1":"_eventId__h1__ZHDU_","h2":"_eventId__h2__31_x3","h3":"_eventId__h3__Id3SZ","h4":"_eventId__h4__ZOXzK","p":"_eventId__p__cxyFn","caption":"_eventId__caption__ioMnF","mx-3":"_eventId__mx-3__Gt017","mb-1":"_eventId__mb-1__9mHKY","mb-2":"_eventId__mb-2__qiM5A","mb-3":"_eventId__mb-3__2gcgt","mb-4":"_eventId__mb-4__0iqB5","mb-5":"_eventId__mb-5__UAAQY","mt-2":"_eventId__mt-2__kji8e","ml-1":"_eventId__ml-1__Q0giv","p-2":"_eventId__p-2__5uThl","p-3":"_eventId__p-3__o_EYW","border-box":"_eventId__border-box__nEQNv","d-inline-block":"_eventId__d-inline-block__V45c9","event-page__container":"_eventId__event-page__container__OeAn4","event-page__empty-state":"_eventId__event-page__empty-state__5D3F_","event-page__wrapper":"_eventId__event-page__wrapper__YzVx9","event-page__content":"_eventId__event-page__content__dTeKw","event-page__event-details":"_eventId__event-page__event-details__vI4Qz","event-page__event-details-row":"_eventId__event-page__event-details-row__iuNG9","event-page__image":"_eventId__event-page__image__2IuLM","event-page__event-details-col":"_eventId__event-page__event-details-col__eKC0I","event-page__event-details-users-col":"_eventId__event-page__event-details-users-col__K3f6b","event-page__action-buttons":"_eventId__event-page__action-buttons__rJ3SB","event-page__other_events-col":"_eventId__event-page__other_events-col__zgc2x","event-page__upsell-container":"_eventId__event-page__upsell-container__B_JxQ"};

/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1854,9879,8843,9459,9774,2888,179], function() { return __webpack_exec__(11430); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);